<template>
  <Popper :hover="hover" :interactive="false">
    <slot />
    <template #content>
      <div class="bg-grayscale-2 px-2 py-1 text-xs text-grayscale-96">
        <slot name="content" />
      </div>
    </template>
  </Popper>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";

defineProps({
  hover: {
    type: Boolean,
    default: false,
  },
});
</script>
